// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { styled } from '@mui/material/styles';
import { Link } from 'react-router';

export const LinkUnderline = styled(Link, { shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'sx' })<{
  isActive?: boolean;
}>(({ isActive }) => ({
  textDecoration: 'none',
  border: 'none',
  display: 'inline-block',
  '&::after': {
    borderBottom: '1px solid white',
    content: '""',
    display: 'block',
    transform: isActive === true ? 'scaleX(1)' : 'scaleX(0)',
    transition: 'transform 0.2s ease-in-out',
  },
  '&:hover::after': {
    transform: 'scaleX(1)',
  },
}));

export const LinkTagUnderline = styled('a')({
  textDecoration: 'none',
  border: 'none',
  display: 'inline-block',
  '&::after': {
    borderBottom: '1px solid white',
    content: '""',
    display: 'block',
    transform: 'scaleX(0)',
    transition: 'transform 0.2s ease-in-out',
  },
  '&:hover::after': {
    transform: 'scaleX(1)',
  },
});
